import { Injectable, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: 'root',
})
export class NavService implements OnDestroy {

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize')
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  // Search Box
  public search = false;

  // Language
  public language= false;

  // Mega Menu
  public megaMenu = false;
  public levelMenu = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen = false;

  MENUSTRUCTURE: Menu[] = [
    {path:'/accueil-structure',title: 'Dashboard',icon: 'home',type: 'link',badgeType: 'light-primary',active: true,},
    {path: '/structure/view',title: 'Mon profil',type: 'link',badgeType: 'light-primary',},
    {path: '/demande',title: 'Mes demandes',type: 'link',badgeType: 'light-primary',},
    {path: '/candidat-faq',title: 'Foire aux questions',type: 'link',badgeType: 'light-primary',},
    {path: '/guide',title: "Guide d'utilisation",type: 'link',badgeType: 'light-primary',},

  ];
  MENUADMIN: Menu[] = [
    {title: 'Dashboard',icon: 'home',path:'/admin/accueil',type: 'link',badgeType: 'light-primary',active: true,},
    {path: '/admin/candidat',title: 'Gestion Candidats',type: 'link',badgeType: 'light-primary',},
    {path: '/admin/candidature',title: 'Gestion Candidatures',type: 'link',badgeType: 'light-primary',},
    {path: '/admin/structure',title: 'Gestion Structures',type: 'link',badgeType: 'light-primary',},
    {path: '/admin/demande',title: 'Gestion Demandes',type: 'link',badgeType: 'light-primary',},
    // {path: '/admin/migration',title: 'Gestion migration',type: 'link',badgeType: 'light-primary',},
    {path: '/admin/certificat',title: 'Gestion Certificats',type: 'link',badgeType: 'light-primary',},

    {path: '/admin/offre',title: 'Gestion Offres',type: 'link',badgeType: 'light-primary',},
    {path: '/admin/info',title: 'Gestion informations',type: 'link',badgeType: 'light-primary',},
    {title: "Statistiques", type: "sub", badgeType: "light-primary",
      children: [
        { path: "/admin/statistic/rapport", title: "Rapport mensuel", type: "link" },
      ],
    },
    {title: "Sécurité",type: "sub",badgeType: "light-primary",badgeValue: "1",
      children: [
        { path: "/secu/otp", title: "OTPs", type: "link" },
        { path: "/secu/api-clients", title: "Clients API", type: "link" },
        { path: "/secu/logs", title: "Journal", type: "link" },
        { path: "/secu/profil", title: "Profils", type: "link" },
        { path: "/secu/user", title: "Utilisateurs", type: "link" },
      ],
    }

  ];

  MENUCANDIDAT: Menu[] = [
    {title: 'Dashboard',icon: 'home',path:'/accueil-candidat',type: 'link',badgeType: 'light-primary',active: true,},
    {path: '/candidat/view',title: 'Mon profil',type: 'link',badgeType: 'light-primary',},
    {path: '/candidature',title: 'Candidatures',type: 'link',badgeType: 'light-primary',},
    {path: '/candidat-faq',title: 'Foire aux questions',type: 'link',badgeType: 'light-primary',},
    {path: '/guide',title: "Guide d'utilisation",type: 'link',badgeType: 'light-primary',},
  ];

  // Array
  // items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
  itemsStructure = new BehaviorSubject<Menu[]>(this.MENUSTRUCTURE);
  itemsCandidat = new BehaviorSubject<Menu[]>(this.MENUCANDIDAT);
  itemsAdmin = new BehaviorSubject<Menu[]>(this.MENUADMIN);
  // items = new BehaviorSubject<Menu[]>(this.authService.loggedUser.role.niveau>1?this.MENUCANDIDAT:this.MENUSTRUCTURE);

  ngOnDestroy() {
    // this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }
}
